import { motion } from "framer-motion";
import Reveal from "@/components/Reveal";
import LogoMark from "@/components/LogoMark";

export default function About() {
  return (
    <section
      id="ueber-uns"
      className="relative scroll-mt-24 border-t border-gold/10 bg-wine2/40 py-24 md:py-32"
      data-testid="about-section"
    >
      <motion.div
        className="pointer-events-none absolute -right-24 bottom-0 opacity-[0.06]"
        aria-hidden="true"
      >
        <LogoMark className="h-80 w-80 animate-spin-slow" />
      </motion.div>

      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 md:px-10 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <div className="relative max-w-sm">
            <div
              className="absolute -inset-3 rounded-t-[12rem] rounded-b-lg border border-gold/25"
              aria-hidden="true"
            />
            <div className="overflow-hidden rounded-t-[12rem] rounded-b-lg border border-white/10">
              <img
                src="https://images.unsplash.com/photo-1622207691293-5cd80466dab3?q=80&w=1000&auto=format&fit=crop"
                alt="Punjabischer Schmuck am Kopf getragen"
                loading="lazy"
                className="h-[440px] w-full object-cover md:h-[540px]"
                data-testid="about-image"
              />
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-7 lg:pl-10">
          <Reveal>
            <p className="mb-4 text-xs font-light uppercase tracking-[0.35em] text-gold">
              03 — Über uns
            </p>
            <h2 className="font-serif text-4xl font-light leading-tight tracking-[-0.02em] text-cream md:text-6xl">
              Von einer Mutter.
              <br />
              <em className="text-goldgrad">Für die Ewigkeit.</em>
            </h2>
          </Reveal>

          <Reveal delay={0.15}>
            <p className="mt-8 max-w-xl text-base font-light leading-relaxed text-rosy md:text-lg">
              Jedes Stück erzählt die Geschichte des Punjab. Mit Liebe ausgewählt
              und von Hand veredelt — echte Handwerkskunst für deine besonderen
              Momente.
            </p>
            <p className="mt-5 max-w-xl text-base font-light leading-relaxed text-rosy md:text-lg">
              Hinter APSARA Kollektion steht eine punjabische Mutter mit einem Leben voller
              Tradition. Sie wählt Schmuck und Suiten persönlich aus — Stück für
              Stück, mit <span className="font-gurmukhi text-gold">ਪਿਆਰ</span> (Pyaar).
            </p>
          </Reveal>

          <Reveal delay={0.3}>
            <blockquote className="mt-10 border-l-2 border-gold/50 pl-6">
              <p className="font-serif text-2xl font-light italic text-cream md:text-3xl">
                „Schmuck ist nicht nur Gold — er ist Erinnerung, die man trägt."
              </p>
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
